module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "t3b"
  }, [_vm._v("\nCONTENTS"), _c('br', {
    staticClass: "calibre4"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre4"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre4"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Text/Section00_0003_split_001#Chapter_1"
    }
  }, [_vm._v("I. BUTTONHOLES")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Text/Section00_0004#Chapter_2"
    }
  }, [_vm._v("II. THE POCKET")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/Text/Section00_0005#Chapter_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III. HENRIETTA'S RED COAT")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/Text/Section00_0006#Chapter_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV. ONE FRIDAY AFTERNOON")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/Text/Section00_0007#Chapter_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V. BILLY AND THE DOLL")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/Text/Section00_0008#Chapter_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI. MISS HESTER MEETS AN OLD ACQUAINTANCE")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/Text/Section00_0009#Chapter_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII. A SURPRISE PARTY")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/Text/Section00_0010#Chapter_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII. A STRANGE VISITOR")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/Text/Section00_0011#Chapter_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX. UNCLE SIDNEY")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/Text/Section00_0012#Chapter_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X. HOMESICK")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/Text/Section00_0013#Chapter_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI. SIGNED, SIMON PETTY")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/Text/Section001#Chapter_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII. A JOURNEY")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7ed4df0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Text/Section00_0002.vue
// module id = 63
// module chunks = 0